module.exports = __webpack_public_path__ + "img/logo.923bdb5a.png";